import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../../lib/api';

export const useAudiencePreviewSize = segmentGroups => {
  const groupsWithSegments = segmentGroups.filter(
    group => group.segments.length > 0,
  );

  // Create a stable key for the query
  const segmentKey = useMemo(() => {
    return groupsWithSegments
      .map(group =>
        group.segments
          .map(s => s.value)
          .sort()
          .join(','),
      )
      .sort()
      .join('|');
  }, [groupsWithSegments]);

  const { data, isLoading } = useQuery(
    ['audiencePreviewSize', segmentKey],
    async () => {
      const segmentGroupsPayload = groupsWithSegments.map(group => ({
        segment_ids: group.segments.map(s => s.value),
      }));

      const response = await api.post(
        '/api/client_admin/audiences/preview_size',
        {
          segment_groups: segmentGroupsPayload,
        },
      );

      return response.data;
    },
    {
      enabled: groupsWithSegments.length > 0,
      staleTime: 30000,
    },
  );

  return {
    audienceSize: data?.audience_size,
    isLoading,
    groupsWithSegments,
  };
};
